import { Link } from 'react-router-dom'
import type { ReactNode } from 'react'
import gridShape from '../../assets/grid-01.svg'
import { BrandMark } from './AppSidebar'

// TailAdmin AuthPageLayout: form on the left (max-w-md, vertically centered), a brand-950 panel on
// the right from lg up with TailAdmin's grid-shape decoration in two corners and the logo centered.
export function AuthLayout({ title, subtitle, children, footer }: {
  title: ReactNode
  subtitle?: ReactNode
  children: ReactNode
  footer?: ReactNode
}) {
  return (
    <div className="relative z-[1] bg-white p-6 sm:p-0">
      <div className="relative flex min-h-screen w-full flex-col justify-center sm:p-0 lg:flex-row">
        <div className="flex flex-1 flex-col lg:w-1/2">
          <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-10">
            <Link to="/" className="mb-10 flex items-center gap-3 lg:hidden">
              <BrandMark icon="R" />
              <span className="text-xl font-semibold text-gray-900">Rabbit</span>
            </Link>
            <div className="mb-5 sm:mb-8">
              <h1 className="mb-2 text-title-sm font-semibold text-gray-800 sm:text-title-md">{title}</h1>
              {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
            </div>
            {children}
            {footer && <div className="mt-5 text-center text-sm font-normal text-gray-700 sm:text-start">{footer}</div>}
          </div>
        </div>

        <div className="relative hidden min-h-screen w-full items-center bg-brand-950 lg:grid lg:w-1/2">
          <div className="relative z-[1] flex items-center justify-center">
            <img src={gridShape} alt="" className="absolute right-0 top-0 -z-[1] w-full max-w-[250px] xl:max-w-[450px]" aria-hidden />
            <img src={gridShape} alt="" className="absolute bottom-0 left-0 -z-[1] w-full max-w-[250px] rotate-180 xl:max-w-[450px]" aria-hidden />
            <div className="flex max-w-xs flex-col items-center">
              <div className="mb-4 flex items-center gap-3">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-500 text-2xl font-semibold text-white">R</span>
                <span className="text-3xl font-semibold text-white">Rabbit</span>
              </div>
              <p className="text-center text-gray-400">Build, run and share data workflows for your business.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

// TailAdmin inline form error.
export function AuthError({ children }: { children: ReactNode }) {
  return <div className="mb-5 rounded-lg border border-error-200 bg-error-50 px-4 py-3 text-sm text-error-600">{children}</div>
}
